/*
Copyright 2025 Adobe. All rights reserved.
This file is licensed to you under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License. You may obtain a copy
of the License at http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software distributed under
the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
OF ANY KIND, either express or implied. See the License for the specific language
governing permissions and limitations under the License.
*/

import { tag as html, TemplateResult } from '../custom-tag.js';

export { setCustomTemplateLiteralTag } from '../custom-tag.js';
export const UploadToCloudIcon = ({
  width = 24,
  height = 24,
  hidden = false,
  title = 'Upload To Cloud',
} = {}): string | TemplateResult => {
  return html`<svg
    xmlns="http://www.w3.org/2000/svg"
    height="${height}"
    viewBox="0 0 36 36"
    width="${width}"
    aria-hidden=${hidden ? 'true' : 'false'}
    role="img"
    fill="currentColor"
    aria-label="${title}"
  >
    <path
      d="M16 33a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1v-9h-4ZM29.572 11.143a6.449 6.449 0 0 0-.726.041 8.144 8.144 0 1 0-15.922-3.236 6.862 6.862 0 0 0-8.407 8.394A3.857 3.857 0 1 0 3.857 24H16v-6h-4.3a.7.7 0 0 1-.7-.7.685.685 0 0 1 .207-.49l6.468-5.685a.5.5 0 0 1 .65 0l6.468 5.685a.685.685 0 0 1 .207.49.7.7 0 0 1-.7.7H20v6h9.572a6.429 6.429 0 0 0 0-12.857Z"
    />
  </svg>`;
};
